import _ from 'lodash';
import { AgentUsageResponse, UIConfig } from './interfaces';
import { CCApiService } from './api-service';
import { ApplicationsService } from './applications-service';

export class AgentUsageService {
  static ApiService: CCApiService;
  private static metricsApi: string;

  static async init(config: UIConfig, customerId) {
    this.ApiService = new CCApiService(config.authClientId, config.authIssuerUri);

    // embeddable metrics endpoint requires an appId, any appId, so we get the list of apps and use the first one to construct the metrics API endpoint
    const apps = await ApplicationsService.getApplications();
    const appId = _.first(apps)?.id;
    this.metricsApi = `${config.apiBasePath}/analytics/${customerId}/${appId}/embeddable/metrics`;
  }

  static async getUsage(requestParams): Promise<AgentUsageResponse> {
    const fetchOptions = {
      method: 'GET',
    };

    const queryParams = {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...requestParams,
    };

    return this.ApiService.performFetch(`${this.metricsApi}/usage?${new URLSearchParams(queryParams)}`, fetchOptions).then(
      result => result
    );
  }

  static async getFacets() {
    const fetchOptions = {
      method: 'GET',
    };

    return this.ApiService.performFetch(`${this.metricsApi}/facets`, fetchOptions).then(
      result => result
    );
  }
}
